<template>
    <div id="container"></div>
</template>
  
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
window._AMapSecurityConfig = {
    securityJsCode: 'a189bfb19abd7ffd825ec1e6b0c3d180'
}
export default {
    data() {
        return {
            map: null
        }
    },
    methods: {
        initMap() {
            AMapLoader.load({
                key: '84074231c120dfe645ee812e67499e1d', // 申请好的Web端开发者Key，首次调用 load 时必填
                version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                plugins: [''] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
            })
                .then((AMap) => {
                    let amap = new AMap.Map('container', { // container为容器的id
                        zoom: 12, //初始化地图层级
                        center: [117.131799,28.940986] //初始化地图中心点
                    });
                    let marker1 = new AMap.Marker({
                        position: [117.118955,28.981592], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    let marker2 = new AMap.Marker({
                        position: [117.119811,28.970092], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    let marker3 = new AMap.Marker({
                        position: [117.115519,28.967265], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    let marker4 = new AMap.Marker({
                        position: [117.142724,28.986178], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    let marker5 = new AMap.Marker({
                        position: [117.133385,28.977531], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    let marker6 = new AMap.Marker({
                        position: [117.135899,28.977608], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    let marker7 = new AMap.Marker({
                        position: [117.130951,28.963294], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    let marker8 = new AMap.Marker({
                        position: [117.149123,28.959356], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    let marker9 = new AMap.Marker({
                        position: [117.167136,28.85967], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    let marker10 = new AMap.Marker({
                        position: [117.090729,29.058922], // 基点位置
                        title: this.$t('app.auto_308_09f5aa98')
                    });
                    // 地图添加标记
                    amap.add(marker1);
                    amap.add(marker2);
                    amap.add(marker3);
                    amap.add(marker4);
                    amap.add(marker5);
                    amap.add(marker6);
                    amap.add(marker7);
                    amap.add(marker8);
                    amap.add(marker9);
                    amap.add(marker10);
                })

                .catch(e => {
                    console.log(e)
                })
        }
    },
    mounted() {
        //DOM初始化完成进行地图初始化
        this.initMap()
    }
}
</script>
  
<style lang="scss">
#container {
    padding: 0px;
    margin: 0px;
    width: 100%;
    height: 100%;
}
</style>
  
  